// extracted by mini-css-extract-plugin
export default {"pagination":"DPiTIMjzPb2m3DIFLrfm"};